import React, { useEffect, useRef, useState } from 'react';
import { History, Location } from 'history';
import { LeavePrompt } from './LeavePrompt.component';

interface LeavePromptBlockProps {
  history: any;
  blockingCondition: boolean;
  confirmAction?: () => Promise<void>;
}

const LeavePromptRedirectionBlock: React.FC<LeavePromptBlockProps> = ({
  history,
  blockingCondition,
  confirmAction,
}) => {
  const handleRedirectionRef = useRef<any>();
  const [isLeavePromptOpen, setIsLeavePromptOpen] = useState<boolean>(false);
  const [redirection, setRedirection] = useState<Location | undefined>(undefined);

  const handleLeavePromptConfirm = async () => {
    setIsLeavePromptOpen(false);
    if (confirmAction) {
      await confirmAction();
    }
    if (handleRedirectionRef && handleRedirectionRef.current) {
      handleRedirectionRef.current();
    }
    if (redirection) {
      history.push(redirection);
    }
  };

  useEffect(() => {
    handleRedirectionRef.current = history.block((targetLocation: any) => {
      if (blockingCondition) {
        setRedirection(targetLocation);
        setIsLeavePromptOpen(true);
        return false;
      }
    });
    return () => {
      handleRedirectionRef.current && handleRedirectionRef.current();
    };
  }, [blockingCondition]);

  if (isLeavePromptOpen) {
    return (
      <LeavePrompt isOpen={true} onConfirm={handleLeavePromptConfirm} onCancel={() => setIsLeavePromptOpen(false)} />
    );
  } else {
    return <></>;
  }
};

export default LeavePromptRedirectionBlock;
